{
  "shell": {
    "logo_alt": "Rhemn",
    "navUpgrade": "ارتقا",
    "navBilling": "صورت‌حساب"
  },
  "upgrade": {
    "badge": "ریمن پرو",
    "title": "زبانه شما. <em>ذکر</em> شما.<br />ارتقایافته.",
    "subtitle": "هر ویژگی که برای روزی هدفمندتر نیاز دارید — از اوقات نماز و تأمل آیه با هوش مصنوعی تا آب‌وهوا و وظایف اولویت‌دار — در یک زبانه نو، آرام و زیبا.",
    "comparison_aria": "مقایسه طرح‌ها",
    "free": {
      "tierLabel": "کنونی",
      "tierName": "رایگان",
      "freeLabel": "همیشه رایگان",
      "list_aria": "ویژگی‌های طرح رایگان"
    },
    "pro": {
      "list_aria": "ویژگی‌های طرح پرو",
      "tierLabel": "ارتقا به",
      "tierName": "پرو",
      "pricePeriod": "/ ماه",
      "priceAlt": "یا $39.99 / سال"
    },
    "freeFeatures": {
      "clockDate": "نمایش ساعت و تاریخ",
      "verseOfDay": "آیه قرآن روز",
      "dailyBackground": "عکس پس‌زمینه روزانه",
      "qiblaCompass": "قطب‌نمای قبله",
      "basicTasks": "وظایف پایه"
    },
    "proFeatures": {
      "weatherForecast": "پیش‌بینی آب‌وهوای ۵ روزه",
      "verseFavorites": "ذخیره و مرور آیه‌های مورد علاقه",
      "notesAi": "یادداشت‌ها با تحلیل هوش مصنوعی",
      "priorityTasks": "مدیریت وظایف اولویت‌دار",
      "verseReflection": "تأمل آیه با هوش مصنوعی"
    },
    "plans": {
      "monthly": {
        "label": "ماهانه",
        "price": "$4.99",
        "period": "/ ماه",
        "note": "صورت‌حساب ماهانه"
      },
      "yearly": {
        "label": "سالانه",
        "price": "$39.99",
        "period": "/ سال",
        "note": "دو ماه رایگان",
        "badge": "۳۳٪ صرفه‌جویی"
      }
    },
    "pricingTitle": "ریمن پرو",
    "pricingDesc": "هر زمان لغو کنید. دسترسی شما تا پایان دوره صورت‌حساب بدون هزینه جزئی ادامه می‌یابد.",
    "billingPeriod_aria": "دوره صورت‌حساب",
    "cta": "ادامه به پرداخت امن",
    "ctaLoading": "در حال هدایت به پرداخت…",
    "promoManual": "برای دریافت تخفیف، کد {{code}} را در صفحهٔ بعد وارد کنید.",
    "signingUpAs": "ثبت‌نام به‌عنوان {{account}}",
    "trustSignals_aria": "نشانه‌های اعتماد",
    "reassurance": {
      "secureCheckout": "پرداخت امن از طریق Stripe",
      "cancelAnytime": "لغو در هر زمان، بدون پرسش",
      "accessUntilEnd": "دسترسی تا پایان دوره"
    },
    "errors": {
      "restoreSession": "بازیابی نشست شما ممکن نشد. لطفاً از طریق افزونه دوباره تلاش کنید.",
      "checkoutFailed": "آغاز پرداخت ناموفق بود. لطفاً دوباره تلاش کنید."
    }
  },
  "upgradeStatus": {
    "unlockedFeatures_aria": "ویژگی‌های گشوده‌شده",
    "unlockedFeatures": {
      "weatherForecast": "پیش‌بینی آب‌وهوای ۵ روزه",
      "verseFavorites": "ذخیره و مرور آیه‌های مورد علاقه",
      "notesAi": "یادداشت‌ها با تحلیل هوش مصنوعی",
      "priorityTasks": "مدیریت وظایف اولویت‌دار",
      "verseReflection": "تأمل آیه با هوش مصنوعی"
    },
    "success": {
      "title": "به پرو خوش آمدید",
      "desc": "اشتراک شما فعال است. به افزونه بازگردید تا همه ویژگی‌های پرو را در انتظار خود بیابید.",
      "viewBilling": "مشاهده جزئیات صورت‌حساب",
      "closeTab": "بستن این زبانه"
    },
    "cancel": {
      "title": "پرداخت لغو شد",
      "desc": "نگران نباشید — طرح شما تغییر نکرد و هزینه‌ای از شما کسر نشد. هر زمان آماده بودید می‌توانید ارتقا دهید.",
      "backToUpgrade": "بازگشت به ارتقا",
      "returnToExtension": "بازگشت به افزونه"
    }
  },
  "billing": {
    "title": "صورت‌حساب",
    "subtitle": "اشتراک خود را مدیریت کنید و تاریخچه پرداخت را ببینید.",
    "subscription_aria": "وضعیت اشتراک",
    "subscriptionTitle": "اشتراک",
    "loading_aria": "در حال بارگذاری اطلاعات صورت‌حساب",
    "planPro": "ریمن پرو",
    "planFree": "ریمن رایگان",
    "statusLabels": {
      "active": "فعال",
      "trialing": "آزمایش رایگان",
      "past_due": "سررسید گذشته",
      "unpaid": "پرداخت‌نشده",
      "canceled": "لغوشده",
      "incomplete": "ناقص",
      "none": "بدون اشتراک"
    },
    "planValues": {
      "proYearly": "پرو · سالانه",
      "proMonthly": "پرو · ماهانه"
    },
    "warnings": {
      "paymentFailedTitle": "پرداخت ناموفق بود",
      "paymentFailedDesc": "آخرین پرداخت شما انجام نشد. برای حفظ دسترسی پرو، روش پرداخت خود را از طریق مدیریت صورت‌حساب به‌روزرسانی کنید.",
      "trialEndingTitle": "آزمایش به‌زودی پایان می‌یابد",
      "trialEndingToday": "آزمایش رایگان شما امروز در {{date}} پایان می‌یابد. برای حفظ ویژگی‌های پرو، روش پرداختی اضافه کنید.",
      "trialEndingInDays_one": "آزمایش رایگان شما تا {{count}} روز دیگر در {{date}} پایان می‌یابد. برای حفظ ویژگی‌های پرو، روش پرداختی اضافه کنید.",
      "trialEndingInDays_other": "آزمایش رایگان شما تا {{count}} روز دیگر در {{date}} پایان می‌یابد. برای حفظ ویژگی‌های پرو، روش پرداختی اضافه کنید."
    },
    "cancellationScheduled": "لغو زمان‌بندی شد. دسترسی کامل پرو شما تا <strong>{{date}}</strong> حفظ می‌شود.",
    "sublabel": {
      "trialEndsToday": "آزمایش امروز پایان می‌یابد",
      "trialDaysRemaining_one": "{{count}} روز باقی‌مانده از آزمایش",
      "trialDaysRemaining_other": "{{count}} روز باقی‌مانده از آزمایش",
      "renews": "تمدید در {{date}}",
      "accessUntil": "دسترسی تا {{date}}"
    },
    "kv": {
      "status": "وضعیت",
      "nextRenewal": "تمدید بعدی",
      "trialEnds": "پایان آزمایش",
      "trialDaysLeft_one": "{{count}} روز باقی",
      "trialDaysLeft_other": "{{count}} روز باقی",
      "endsToday": "امروز پایان می‌یابد",
      "plan": "طرح"
    },
    "upgradeNudge": {
      "title": "ویژگی‌های پرو را بگشایید",
      "desc": "آب‌وهوا، اوقات نماز، تأمل آیه با هوش مصنوعی و بیشتر — $4.99 در ماه یا $39.99 در سال.",
      "cta": "ارتقا"
    },
    "actions": {
      "manageBilling": "مدیریت صورت‌حساب و روش پرداخت",
      "cancelConfirmTitle": "اشتراک خود را لغو می‌کنید؟",
      "cancelConfirmDesc": "دسترسی کامل پرو را تا پایان دوره صورت‌حساب کنونی حفظ خواهید کرد. بازپرداخت جزئی صادر نمی‌شود.",
      "canceling": "در حال لغو…",
      "yesCancel": "بله، لغو کن",
      "keepPro": "حفظ پرو",
      "cancelSubscription": "لغو اشتراک"
    },
    "noSubscription": "اشتراکی یافت نشد.",
    "paymentHistory_aria": "تاریخچه پرداخت",
    "paymentHistoryTitle": "تاریخچه پرداخت",
    "invoices_aria": "فاکتورها",
    "invoiceView": "مشاهده",
    "invoiceView_aria": "مشاهده فاکتور از {{date}}",
    "noInvoices": "هنوز فاکتوری نیست.",
    "dangerZone_aria": "ناحیه خطر",
    "dangerZoneTitle": "ناحیه خطر",
    "deleteAccountTitle": "حذف حساب",
    "deleteAccountDesc": "حساب خود و همه داده‌های مرتبط — وظایف، یادداشت‌ها، علاقه‌مندی‌ها و تاریخچه صورت‌حساب — را برای همیشه حذف کنید. این اقدام قابل بازگشت نیست.",
    "deleteAccountBtn": "حذف حساب",
    "deleteConfirm": {
      "warning": "این کار فوراً و برای همیشه:",
      "list": {
        "deleteContent": "همه وظایف، یادداشت‌ها و آیه‌های مورد علاقه شما را حذف می‌کند",
        "cancelSubscription": "هر اشتراک فعال را لغو می‌کند (بدون بازپرداخت زمان استفاده‌نشده)",
        "removeAccount": "حساب شما را از پایگاه‌داده ما حذف می‌کند",
        "signOut": "شما را از همه دستگاه‌ها خارج می‌کند"
      },
      "typeToConfirm": "برای تأیید <strong>DELETE</strong> را تایپ کنید",
      "inputPlaceholder": "DELETE",
      "deleting": "در حال حذف…",
      "confirmBtn": "حساب من را برای همیشه حذف کن",
      "cancelBtn": "لغو"
    },
    "errors": {
      "loadFailed": "بارگذاری اطلاعات صورت‌حساب ناموفق بود.",
      "cancelFailed": "لغو اشتراک ناموفق بود.",
      "deleteFailed": "حذف حساب ناموفق بود. لطفاً دوباره تلاش کنید یا با پشتیبانی تماس بگیرید.",
      "portalFailed": "گشودن درگاه صورت‌حساب ناموفق بود."
    }
  },
  "privacy": {
    "tocLabel": "سیاست حریم خصوصی",
    "toc_aria": "فهرست مطالب",
    "lastUpdated": "آخرین به‌روزرسانی<br />۲۲ سپتامبر ۲۰۲۶",
    "sections": {
      "overview": "نمای کلی",
      "informationWeCollect": "اطلاعاتی که گردآوری می‌کنیم",
      "connectedServices": "سرویس‌های متصل (Google، Todoist، Apple)",
      "howWeUse": "چگونه از اطلاعات شما استفاده می‌کنیم",
      "howWeShare": "چگونه اطلاعات شما را به اشتراک می‌گذاریم",
      "dataRetention": "نگهداری داده‌ها",
      "yourRights": "حقوق حریم خصوصی شما",
      "california": "ساکنان کالیفرنیا (CCPA/CPRA)",
      "cookies": "کوکی‌ها و حافظه محلی",
      "security": "امنیت داده‌ها",
      "changes": "تغییرات این سیاست",
      "contact": "تماس با ما"
    },
    "headings": {
      "informationWeCollect": "اطلاعاتی که گردآوری می‌کنیم",
      "connectedServices": "سرویس‌های متصل (Google، Todoist، Apple)",
      "howWeUse": "چگونه از اطلاعات شما استفاده می‌کنیم",
      "howWeShare": "چگونه اطلاعات شما را به اشتراک می‌گذاریم",
      "dataRetention": "نگهداری داده‌ها",
      "yourRights": "حقوق حریم خصوصی شما",
      "california": "ساکنان کالیفرنیا (CCPA / CPRA)",
      "cookies": "کوکی‌ها و حافظه محلی",
      "security": "امنیت داده‌ها",
      "changes": "تغییرات این سیاست",
      "contact": "تماس با ما"
    }
  },
  "deleteAccount": {
    "intro": "حذف حساب شما این موارد را برای همیشه پاک می‌کند:",
    "list": {
      "account": "حساب و نمایه شما",
      "tasks": "همه وظایف",
      "notes": "همه یادداشت‌ها",
      "verses": "آیات ذخیره‌شده",
      "billing": "سوابق اشتراک"
    },
    "irreversible": "این کار قابل بازگشت نیست.",
    "appleNotice": "حذف حساب، اشتراکی را که از App Store خریده‌اید لغو نمی‌کند. لطفاً آن را در تنظیمات ← Apple ID ← Subscriptions نیز لغو کنید.",
    "manageSubscription": "مدیریت اشتراک",
    "continueBtn": "ادامه حذف",
    "keepBtn": "حسابم را نگه دار",
    "confirmTitle": "حساب شما حذف شود؟",
    "confirmDesc": "حساب شما و همه داده‌های آن برای همیشه حذف خواهد شد. این کار قابل بازگشت نیست.",
    "confirmBtn": "حساب من را برای همیشه حذف کن",
    "deleting": "در حال حذف…",
    "error": "حذف حساب شما ممکن نشد. لطفاً اتصال خود را بررسی کنید و دوباره تلاش کنید."
  }
}
